import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom"; // Import navigation

const HomeContact = () => {
  const navigate = useNavigate(); // Initialize navigation
  return (
    <Box
      sx={{padding: "40px",
        display: "flex",
        justifyContent: "center",
        
        backgroundColor:"#C4D8E2",
      }}
    >
      {/* Inner Box */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          background: "radial-gradient(circle, #1F6788,#161623)",
          color: "white",
          padding: "50px",
          borderRadius: "20px",
          width: { xs: "90%", md: "80%" },
          minHeight: "250px",
         // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          position: "relative",
          boxShadow: `
          0px 12px 25px rgba(0, 0, 0, 0.6),  
          inset 0px 10px 20px rgba(255, 255, 255, 0.15),
          inset 0px -10px 30px rgba(0, 0, 0, 0.7),
          inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
          inset -10px 0px 20px rgba(255, 255, 255, 0.2)
        `,
        }}
      >
        {/* Left Content */}
        <Box sx={{ flex: 1, textAlign: "left" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              marginBottom: "10px",
              textAlign: { xs: "center", md: "left" },
              fontSize: { xs: "24px", sm: "28px", md: "32px" },
            }}
          >
            Need Assistance? Our Tech Experts are Just a Click Away
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Typography variant="h3" sx={{ fontWeight: "bold", color: "white" }}>
              30
            </Typography>
            <Typography variant="body1">Minutes is all it takes to hear from us</Typography>
          </Box>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
              padding: "10px 20px",
              marginTop: "15px",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#d00000" },
            }}
            onClick={() => navigate("/contact")}
          >
            Reach Out Now
          </Button>
        </Box>

        {/* Right Content - Triangle Positioned Images (Hidden on Mobile) */}
        <Box
          sx={{
            flex: 1,
            display: { xs: "none", md: "flex" }, // Hide on mobile
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            height: "200px",
          }}
        >
          {/* Large Images in Triangle */}
          {["face1.jpg", "face2.png", "face3.jpg"].map((img, index) => (
            <img
              key={index}
              src={`${process.env.PUBLIC_URL}/image/${img}`}
              alt={`User${index + 1}`}
              style={{
                position: "absolute",
                top: index === 0 ? "0" : "auto",
                bottom: index !== 0 ? "0" : "auto",
                left: index === 1 ? "30%" : index === 2 ? "auto" : "50%",
                right: index === 2 ? "30%" : "auto",
                marginLeft: index === 0 ? "-60px" : "0", // Fix for first image
                width: index === 0 ? "120px" : index === 1 ? "100px" : "80px",
                height: index === 0 ? "120px" : index === 1 ? "100px" : "80px",
                borderRadius: "50%",
                border: "2px solid white",
                transition: "transform 0.3s ease-in-out",
                cursor: "pointer",
                boxShadow: `
                0px 12px 25px rgba(0, 0, 0, 0.6),  
                inset 0px 10px 20px rgba(255, 255, 255, 0.15),
                inset 0px -10px 30px rgba(0, 0, 0, 0.7),
                inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
                inset -10px 0px 20px rgba(255, 255, 255, 0.2)
              `,
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
              }}
            />
          ))}

          {/* Smaller Images in a Curve */}
          {["face4.jpg", "face5.jpg", "face1.jpg"].map((img, index) => (
            <img
              key={index}
              src={`${process.env.PUBLIC_URL}/image/${img}`}
              alt={`User${index + 4}`}
              style={{
                position: "absolute",
                top: index === 0 ? "20%" : index === 1 ? "30%" : "auto",
                bottom: index === 2 ? "10%" : "auto",
                left: index === 0 ? "35%" : index === 2 ? "50%" : "auto",
                right: index === 1 ? "30%" : "auto",
                transform: index === 2 ? "translateX(-50%)" : "none",
                width: index === 0 ? "50px" : index === 1 ? "60px" : "30px",
                height: index === 0 ? "50px" : index === 1 ? "60px" : "30px",
                borderRadius: "50%",
                border: "2px solid white",
                transition: "transform 0.3s ease-in-out",
                cursor: "pointer",
                boxShadow: `
                0px 12px 25px rgba(0, 0, 0, 0.6),  
                inset 0px 10px 20px rgba(255, 255, 255, 0.15),
                inset 0px -10px 30px rgba(0, 0, 0, 0.7),
                inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
                inset -10px 0px 20px rgba(255, 255, 255, 0.2)
              `,
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default HomeContact;
